import type {BaseLinkModel} from "../../../../../infrastructure/models/link/base-link-model";
import {COMPETITION_CONTAINER} from "../../../../../containers/competition-container/competition-container.consts";
import type {CompetitionViewModel} from "../../../../../domain/common/competition/models/competition-view-model";
import {ANALYTICS} from "../../../../../third-party-services/analytics/analytics-consts";
import {InsightsTabModel} from "../insights.tab-model";
import {CompetitionInsightsPageLinkModel} from "../../../../../containers/competition-container/pages/insights-page/models/competition-insights-page.link-model";

export class CompetitionInsightsPageTabModel extends InsightsTabModel {
  index: Number;
  name: String;
  entity: CompetitionViewModel;
  currentLinkModel: BaseLinkModel;

  constructor(
    index: Number,
    name: String,
    entity: CompetitionViewModel,
    currentLinkModel: BaseLinkModel
  ) {
    super(index, name)

    this.entity = entity;
    this.currentLinkModel = currentLinkModel;
  }

  get linkModel(): CompetitionInsightsPageLinkModel {
    const linkModel: CompetitionInsightsPageLinkModel = new CompetitionInsightsPageLinkModel(this.entity.id, this.entity.sport.nameForURL, this.entity.nameForURL, this.entity.isFollow);

    return linkModel;
  }

  get isActive(): Boolean {
    return this.currentLinkModel.params.page === COMPETITION_CONTAINER.FILTERS.insights;
  }

  get analyticsEntityType(): Object {
    return ANALYTICS.ENTITY_TYPES.competition;
  }

  get eventName() {
    return null
  }
}
